import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router"

const routes: Array<RouteRecordRaw> = [
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/LoginView.vue"),
  },
  {
    path: "/exit",
    name: "exit",
    component: () => import("@/views/ExitView.vue"),
  },
  {
    path: "/contact",
    name: "contact",
    component: () => import("@/views/ContactView.vue"),
  },
  {
    path: "/about",
    name: "about",
    component: () => import("@/views/AboutView.vue"),
  },
  {
    path: "/",
    name: "home",
    component: () => import("@/views/HomeView.vue"),
  },
  {
    path: "/bill",
    name: "bill",
    component: () => import("@/views/BillView.vue"),
  },
  {
    path: "/readings",
    name: "readings",
    component: () => import("@/views/ReadingsView.vue"),
  },
  {
    path: "/password",
    name: "password",
    component: () => import("@/views/PasswordView.vue"),
  },
  {
    path: "/ip",
    name: "ip",
    component: () => import("@/views/IPView.vue"),
  },
  {
    path: "/users",
    name: "users",
    component: () => import("@/views/UsersView.vue"),
  },
  {
    path: "/404",
    name: "404",
    component: () => import("@/views/Err404View.vue"),
  },
  {
    path: "/500",
    name: "500",
    component: () => import("@/views/Err500View.vue"),
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/404",
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
